export namespace InjectSituationType {
  export const TransactionManager = Symbol.for('simple-boot-http-server:transaction-manager-token');
}